import React, {useRef, useState} from "react";
import NoImage from '../../../assets/img/no-img_small.svg';

const ImageCell: React.FC<{ value: string | null }> = ({ value }) => {
    const [originClass, setOriginClass] = useState<'origin-top-left' | 'origin-bottom-left'>('origin-top-left');
    const ref = useRef<HTMLDivElement | null>(null);

    const handleMouseEnter = () => {
        const el = ref.current;
        const table = el?.closest('.table-products');

        if (!el || !table) return;

        const elRect = el.getBoundingClientRect();
        const tableRect = table.getBoundingClientRect();

        const spaceTop = elRect.top - tableRect.top;
        const spaceBottom = tableRect.bottom - elRect.bottom;

        const next = spaceBottom < spaceTop ? 'origin-bottom-left' : 'origin-top-left';
        setOriginClass(prev => (prev === next ? prev : next));
    };

    return (
        <div
            ref={ref}
            className={`img-zoom ${originClass}`}
            onMouseEnter={handleMouseEnter}
        >
            {value ? (
                <div>
                    <span></span>
                    <div className="img-wrapper">
                        <img src={value} width="342" />
                    </div>
                </div>
            ) : (
                <div className="img-wrapper">
                    <img src={NoImage} width="342" />
                </div>
            )}
        </div>
    );
};

export default ImageCell;